/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  speedDial: Item<'SpeedDial'>;
  speedDialAction: Item<'SpeedDialAction'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  speedDialAction1: Item<'SpeedDialAction'>;
  triggerOnClick1: Item<'TriggerOnClick'>;
  speedDialAction2: Item<'SpeedDialAction'>;
  triggerOnClick2: Item<'TriggerOnClick'>;
  actionShowMessage: Item<'ActionShowMessage'>;
  actionShowMessage1: Item<'ActionShowMessage'>;
  actionShowMessage2: Item<'ActionShowMessage'>;
} = {
  actionShowMessage: {
    children: [],
    itemId: 'actionShowMessage',
    parent: 'triggerOnClick2',
    props: {
      message: {
        type: 'text',
        value: 'You clicked Gamma',
      },
      type: 'success',
    },
    type: 'ActionShowMessage',
  },
  actionShowMessage1: {
    children: [],
    itemId: 'actionShowMessage1',
    parent: 'triggerOnClick1',
    props: {
      message: {
        type: 'text',
        value: 'You clicked Beta',
      },
      type: 'success',
    },
    type: 'ActionShowMessage',
  },
  actionShowMessage2: {
    children: [],
    itemId: 'actionShowMessage2',
    parent: 'triggerOnClick',
    props: {
      message: {
        type: 'text',
        value: 'You clicked Alpha',
      },
      type: 'success',
    },
    type: 'ActionShowMessage',
  },
  root: {
    children: ['speedDial'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
  speedDial: {
    children: ['speedDialAction', 'speedDialAction1', 'speedDialAction2'],
    itemId: 'speedDial',
    parent: 'root',
    props: {},
    type: 'SpeedDial',
  },
  speedDialAction: {
    children: ['triggerOnClick'],
    itemId: 'speedDialAction',
    parent: 'speedDial',
    props: {
      icon: {
        iconName: 'plus',
        iconType: 'light',
      },
      name: 'Alpha',
    },
    type: 'SpeedDialAction',
  },
  speedDialAction1: {
    children: ['triggerOnClick1'],
    itemId: 'speedDialAction1',
    parent: 'speedDial',
    props: {
      icon: {
        iconName: 'edit',
        iconType: 'light',
      },
      name: 'Beta',
    },
    type: 'SpeedDialAction',
  },
  speedDialAction2: {
    children: ['triggerOnClick2'],
    itemId: 'speedDialAction2',
    parent: 'speedDial',
    props: {
      icon: {
        iconName: 'trash',
        iconType: 'light',
      },
      iconColor: { type: 'text', value: 'error' },
      name: 'Gamma',
    },
    type: 'SpeedDialAction',
  },
  triggerOnClick: {
    children: ['actionShowMessage2'],
    itemId: 'triggerOnClick',
    parent: 'speedDialAction',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick1: {
    children: ['actionShowMessage1'],
    itemId: 'triggerOnClick1',
    parent: 'speedDialAction1',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick2: {
    children: ['actionShowMessage'],
    itemId: 'triggerOnClick2',
    parent: 'speedDialAction2',
    props: {},
    type: 'TriggerOnClick',
  },
};

export const helpRenders: ComponentSample<'SpeedDial'>[] = [
  {
    title: 'Speed Dial',
    description: 'Try changing the direction prop!',
    page,
    exampleId: 'eg1',
    clearParentChildren: true,
    height: 260,
    visibleProps: ['direction'],
    item: {
      itemId: 'speedDial',
      type: 'SpeedDial',
      children: ['speedDialAction', 'speedDialAction1', 'speedDialAction2'],
      parent: 'root',
      props: {
        direction: 'up',
      },
    },
  },
];
